import { render } from "./ListOrganismes.vue?vue&type=template&id=2652d0ba"
import script from "./ListOrganismes.vue?vue&type=script&lang=js"
export * from "./ListOrganismes.vue?vue&type=script&lang=js"

import "./ListOrganismes.vue?vue&type=style&index=0&id=2652d0ba&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__